import { sagas as documentSagas } from './modules/documents'

export default [...documentSagas]
